import Vue from 'vue'

import shortDate from './date-format'
import longDate from './date-time-format'
import shortTime from './time-format'
import shortMonth from './month-format'

Vue.filter('shortDate', shortDate)
Vue.filter('longDate', longDate)
Vue.filter('shortTime', shortTime)
Vue.filter('shortMonth', shortMonth)
